import { supabase } from '../../lib/supabase'

export interface UserProfile {
  contact_method: string | null
  contact_value: string | null
  contact_sharing_enabled: boolean
  notifications_enabled: boolean
  locale: string
}

export async function getProfile(): Promise<UserProfile | null> {
  const { data, error } = await supabase.rpc('user_profile_get')
  if (error) throw error
  return (data?.[0] as UserProfile | undefined) ?? null
}

export async function saveProfile(profile: UserProfile) {
  const { error } = await supabase.rpc('user_profile_upsert', {
    p_contact_method: profile.contact_method,
    p_contact_value: profile.contact_value,
    p_contact_sharing_enabled: profile.contact_sharing_enabled,
    p_notifications_enabled: profile.notifications_enabled,
    p_locale: profile.locale,
  })
  if (error) throw error
}

export async function exportUserData() {
  const { data, error } = await supabase.rpc('user_data_export')
  if (error) throw error
  return data
}

export async function deleteUserAccount() {
  const { error } = await supabase.rpc('user_account_delete')
  if (error) throw error
  await supabase.auth.signOut({ scope: 'local' })
}

export async function registerDeviceToken(token: string, platform: 'ios' | 'android' | 'web') {
  const { error } = await supabase.rpc('device_token_register', {
    p_token: token,
    p_platform: platform,
  })
  if (error) throw error
}

export async function clearDeviceTokens() {
  const { error } = await supabase.rpc('device_tokens_clear')
  if (error) throw error
}

export async function unregisterDeviceToken(token: string) {
  const { error } = await supabase.rpc('device_token_unregister', { p_token: token })
  if (error) throw error
}
